import ApiHelper from "../../../shared/ApiHelper";
import Settings from "../../../constants/Settings";
import { IHabitatServiceObj, ILocationServiceObj } from "../../../shared/apiServices/IApiInterfaces";

const ManageHabitatsApiHelpers = {
    getAllHabitats: async (): Promise<IHabitatServiceObj[]> => {
        return (await ApiHelper.get(`${Settings.HabitatUrl}/habitats`, true)).data;
    },
    getAllHabitatLocations: async (): Promise<ILocationServiceObj[]> => {
        return (await ApiHelper.get(`${Settings.HabitatUrl}/locations`, true)).data;
    },
    getAllHabitatTypes: async () => {
        //TODO work with Randy Belen and api team to see about ref table - currently doesn't exist
        return ['birdbox'];
    },
    deleteHabitat: async (id: number): Promise<any> => {
        return (await ApiHelper.delete(`${Settings.HabitatUrl}/habitats/${id}`, true));
    },
    
    editHabitat: async (id: number, name: string, number: string, locationId: number, type: string): Promise<any> => {
        const reqObj: IHabitatReq = {name, number, locationId, type, id};
        return (await ApiHelper.put(`${Settings.HabitatUrl}/habitats/${id}`, true, reqObj));
    },
    saveHabitat: async (name: string, number: string, locationId: string, type: string): Promise<any> => {
        const saveObj: any = {
            name,
            number,
            locationId,
            type
        };

        return (await ApiHelper.post(`${Settings.HabitatUrl}/habitats`, true ,saveObj)).data;
    }
}

export default ManageHabitatsApiHelpers
